/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
/**
 * The internal dependencies.
 */
import PersonIcon from '../../../assets/images/temp/ico-user-alt.png';
import * as R from "ramda";
import {getWorkstepLabel, getWorkstepName} from "../../../common/utilities";

const Wrapper = styled.div`
	touch-action: none;
	display: flex;
	flex-direction: column;
	color: ${({white}) => white ? '#fff' : '#3B3B3B'};
	width: 100%;
	background: ${({color}) => color};
	padding: 0 4px;
	border-radius: 2px;
	margin-bottom: 1px;
`;

const Row = styled.div`
	display: flex;
	justify-content: ${({spread}) => spread ? 'space-between' : 'initial'};
	padding: 7px 0 11px;

	+ div {
		border-top: 1px solid #ffffffab;
	}

	> span + span {
		border-color: ${({white}) => white ? '#fff' : '#3B3B3B'};
		border-left: ${({delimeter}) => delimeter ? '1px solid' : 'none'};
	}
`;

const RowEntry = styled.span`
	display: flex;
	align-items: flex-end;
	line-height: 1;
	letter-spacing: -.01em;
	color: ${({color}) => color ? color : 'inherit'};
	text-align: ${({align}) => align ? align : 'initial'};
	font-size: ${({large}) => large ? '18' : '9'}px;
	font-weight: ${({bold}) => bold ? '600' : '400'};
	padding-right: ${({padRight}) => padRight ? '6px' : 0};
	padding-left: ${({padLeft}) => padLeft ? '6px' : 0};
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

const Client = styled.div`
	background: rgba(255, 255, 255, 0.7);
	padding: 5px 15px;
	font-size: 9px;
	font-weight: 600;
	color: #3b3b3b;
`;

const Icon = styled.img`
	filter: ${({makeWhite}) => makeWhite
    ? 'brightness(0) invert(1)'
    : 'none'
    };
`;

const allowedColors = {
    'done': '#8fd5ba',
    'reserved': '#686871',
    'in-progress': '#b5aba3',
    'failed': 'repeating-linear-gradient(-55deg, #f43d3d, #f43d3d 15px, #f76d6d 10px, #f76d6d 30px)',
};

const Error = ({
                   task,
                   handleClick,
                   workstepcount,
                   noworkplace,
                   allWorkSteps,
               }) => {
    // const color = allowedColors[task.status]
    //     ? allowedColors[task.status]
    //     : '#a6d9f8';
    //
    // const isWhite = ['reserved', 'failed'].indexOf(task.status) > -1;
    // const reservedColor = task.status === 'reserved' ? '#42AFFA' : null;
    //
    // let img = false;
    //
    // if (task.status === 'done' && task.step === 15){
    //     img = true;
    // }

    let stepName = getWorkstepLabel(allWorkSteps, task.step) + '-' + getWorkstepName(allWorkSteps, task.step);

    const color = allowedColors['failed'];
    const isWhite = false;
    const reservedColor = null;

    return (
        <Wrapper color={color} white={isWhite} onClick={handleClick} id={task.id}>
            <Row spread>
                <RowEntry bold large>
                    {task.quantity}

                    <RowEntry>&nbsp;Stk.</RowEntry>
                </RowEntry>

                <RowEntry>
                    {/*<RowEntry bold large padRight>{task.erpnumber}</RowEntry>*/}

                    <Client>{task.client}</Client>
                </RowEntry>
            </Row>

            <Row>
                <RowEntry bold>{task.erpnumber}</RowEntry>
            </Row>

            {!noworkplace &&<Row delimeter white={isWhite}>
                <RowEntry padRight>
                    <RowEntry bold color={reservedColor}>{task.quantity}&nbsp;</RowEntry>

                    von

                    <RowEntry bold>&nbsp;{task.originalQuantity} Stk.</RowEntry>
                </RowEntry>

                <RowEntry padLeft padRight>
                    Platz <RowEntry bold color={reservedColor}>&nbsp;{task.place}</RowEntry>
                </RowEntry>

                <RowEntry padLeft>
                    Schritt

                    <RowEntry bold color={reservedColor}>&nbsp;{task.step}&nbsp;</RowEntry>

                    von

                    <RowEntry bold>&nbsp;{workstepcount}</RowEntry>
                </RowEntry>

            </Row>}

            {noworkplace &&<Row delimeter white={isWhite}>
                <RowEntry padRight>
                    <RowEntry bold color={reservedColor}>{task.quantity}&nbsp;</RowEntry>

                    von

                    <RowEntry bold>&nbsp;{task.originalQuantity} Stk.</RowEntry>
                </RowEntry>

                <RowEntry padLeft>
                    Schritt:

                    <RowEntry bold color={reservedColor}>&nbsp;{stepName}&nbsp;</RowEntry>
                </RowEntry>

            </Row>}

            <Row spread>
                <RowEntry>
                    <Icon src={PersonIcon} makeWhite={!Boolean(reservedColor)}/>

                    &nbsp;{task.worker}
                </RowEntry>

                <RowEntry>
                    Bis {moment(task.order_deadline).format('DD.MM.')}
                </RowEntry>
            </Row>
        </Wrapper>
    );
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/dashboard/grid/errortracking.js